<template>
  <div id="assist__choose" class="animated fadeIn" ref="main">
    <div ref="container" class="container animated slideInUp" v-if="!coupon">
      <h1 v-if="title">{{ title }}</h1>
      <div class="input-wrapper">
        <h3 class="title">手机号</h3>
        <div class="input" :class="{ active: active === 'phone' }">
          <span>+86</span>
          <input
            v-model="phone"
            type="tel"
            ref="phoneInput"
            placeholder="您的手机号码"
            @focus="focus('phone')"
            @blur="active = null"
          />
        </div>
      </div>
      <div class="input-wrapper">
        <h3 class="title">验证码</h3>
        <div class="input" :class="{ active: active === 'smsCode' }">
          <input
            v-model="smsCode"
            type="tel"
            placeholder="4 位验证码"
            ref="smsInput"
            @focus="focus('smsCode')"
            @blur="active = null"
          />
          <div class="get-code" v-if="smsState == 0" @click="sendSms()">发送短信</div>
          <div class="get-code countdown" v-if="smsState === 1">{{ smsCountdown }} 秒</div>
        </div>
      </div>
      <div class="btn-primary" @click="submit()">领取{{ newUserReward }}学习券</div>
      <div class="btn-hint" @click="cancel">暂不绑定手机号</div>
    </div>
    <div ref="container" class="container animated" id="coupon" v-if="coupon">
      <h1 v-if="title" class="animated tada" id="slow_animation">恭喜您，获得 {{ coupon.length }} 张学习券</h1>
      <Coupon v-for="(value, key) in coupon" :key="key" :coupon="value" :is-list-view="true" />
      <div class="btn-primary" @click="success">继续</div>
    </div>
  </div>
</template>

<script>
import Coupon from "@/components/public/Coupon.vue"
export default {
  name: "Phone",
  props: ["title"],
  components: {
    Coupon,
  },
  data() {
    return {
      isLoading: false,
      active: null,
      phone: "",
      smsCode: "",
      smsState: 0,
      smsCountdown: 60,
      numRegExp: new RegExp("^[0-9]*$"),
      coupon: null,
    }
  },
  computed: {
    newUserReward: function () {
      return this.$store.state.newUserReward ? ` ${this.$store.state.newUserReward} 元` : ""
    },
  },
  watch: {
    phone: function (newVal, oldVal) {
      if (newVal.indexOf(" ") > 0 || newVal.length > 11 || !this.numRegExp.test(newVal)) {
        this.phone = oldVal
      }
      if (newVal.length === 11 && this.numRegExp.test(newVal)) {
        this.$refs.smsInput.focus()
        this.sendSms()
      }
    },
    smsCode: function (newVal, oldVal) {
      if (newVal.length > 4 || !this.numRegExp.test(newVal)) {
        this.smsCode = oldVal
      }
      if (
        newVal.length === 4 &&
        this.numRegExp.test(newVal) &&
        this.phone.length === 11 &&
        this.numRegExp.test(this.phone)
      ) {
        this.$refs.smsInput.blur()
        this.submit()
      }
    },
    isLoading: function (val) {
      if (val) {
        this.$toastLoading("加载中...")
      } else {
        this.$toastHide()
      }
    },
  },
  methods: {
    focus(e) {
      this.active = e
    },
    cancel() {
      this.close()
      this.$emit("auth", false)
    },
    success() {
      this.close()
      this.$emit("auth", true)
    },
    close() {
      this.$refs.container.classList.add("slideOutDown")
      this.$refs.main.classList.add("fadeOut")
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    async submit() {
      const resMsg = {
        "1001": "注册成功",
        "1002": "绑定成功",
        "1003": "此手机号已被绑定",
        "1004": "注册成功",
        "1005": "登陆成功",
      }
      if (this.phone.length !== 11 || !/^[0-9]*$/.test(this.phone)) {
        return this.$toast("请输入 11 位手机号")
      }
      if (this.smsCode.length !== 4 || !/^[0-9]*$/.test(this.smsCode)) {
        return this.$toast("请输入 4 位短信数字验证码")
      }
      this.isLoading = true
      try {
        let { code, msg } = await this.$api.auth.PHONE_LOGIN({
          phone: this.phone,
          number: this.smsCode,
          phone_code: "86"
        })
        code = parseInt(code)
        if (code >= 2000) {
          return this.$toastError(`${msg}（${code}）`)
        }
        if (code == "1003") {
          return this.$toastError(resMsg[code])
        }
        this.$store.commit("user", msg)
        this.$store.commit("login", true)

        // 领取学习券
        this.coupon = await this.$api.user.GET_COUPON()
        this.isLoading = false
        if (!this.coupon) {
          this.$toastSuccess(resMsg[code])
          this.success()
        } else {
          this.$toastSuccess("领取成功")
        }
      } catch (err) {
        this.isLoading = false
        this.$toastError("登陆失败，请稍后重试")
      }
    },
    async getCoupon() {
      this.coupon = await this.$api.user.GET_COUPON()
    },
    setSmsCountdown() {
      const timeout = (this.smsCountdown + 1) * 1000
      setTimeout(() => {
        window.clearInterval(countdown)
        this.smsCountdown = timeout / 1000 - 1
        this.smsState--
      }, timeout)
      const countdown = window.setInterval(() => {
        this.smsCountdown--
      }, 1000)
    },
    async sendSms() {
      if (this.smsState === 1) {
        return
      }
      if (this.phone.length < 11) {
        return this.$toast("请输入 11 位手机号")
      }
      this.setSmsCountdown()
      this.smsState = 1
      this.smsCode = ""

      try {
        const { code, msg } = await this.$api.auth.SEND_SMS(this.phone)
        if (code != 1000) {
          return this.$toastError(`${msg}（${code}）`)
        }
        return this.$toastSuccess("已发送短信验证码")
      } catch (err) {
        this.$toastError("发送验证码失败，请稍后重试")
      }
    },
  },
  mounted() {
    this.$refs.phoneInput.focus()
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#assist__choose {
  background: $blackBgd;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
}

.animated {
  animation-delay: 0s !important;
  animation-duration: 0.5s !important;
}
#slow_animation {
  animation-duration: 0.8s !important;
}

.container {
  padding: 15px;
  background: white;
  width: 90%;
  margin: 0 auto 50px auto;
  max-width: 400px;
}

.disabled {
  @include secondary();
}

h1 {
  @include avenir-demi();
  font-size: 1.3rem;
  margin: 10px 0 20px 0;
}
.input-wrapper {
  margin: 0 0 20px 0;
  * {
    line-height: 1;
  }
  &:last-of-type {
    margin: 0 0 5px 0;
  }
  h3 {
    font-size: 0.8rem;
    @include avenir-demi();
  }

  .input {
    border: 2px solid #eee;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    transition: all 0.1s;
    span {
      @include avenir();
      margin: 0;
      padding: 0 5px 0 0;
      font-size: 1rem;
      opacity: 0.6;
    }
    input {
      border: none;
      margin: 0;
      padding: 0;
      font-size: 1rem;
      color: $purple;
      @include avenir-demi();
      &::-webkit-input-placeholder,
      &::placeholder {
        line-height: 1;
        @include avenir();
        font-weight: 400;
      }
    }
  }
  .active {
    border-color: $purple;
  }
}

.get-code {
  font-size: 0.8rem;
  color: $purple;
  width: 80px;
  @include avenir-demi();
  text-align: right;
  transition: all 0.1s;
  &:active {
    opacity: 0.6;
  }
}
.countdown {
  color: $black;
  opacity: 0.6;
  @include avenir();
  font-weight: 400;
}

#coupon {
  .btn-primary {
    margin-top: 15px;
  }
}
</style>
